import React from "react";
import { Container } from "./Dropdown.styles";
import UI from "@mile-meeting/mile-ui";

type DropdownItemProps = {
  label?: string;
  onClick: () => void;
  selected?: boolean;
  placeholder?: string;
};

const DropdownItem: React.FC<DropdownItemProps> = ({ label, onClick, selected = false, placeholder }) => {
  return (
    <Container onClick={onClick}>
      <UI.Typography
        style={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          overflow: "hidden",
        }}
        type="label01"
        fontStyle={selected ? "bold" : "regular"}
        color={label ? "var(--alias-color-label-normal)" : "var(--alias-color-label-alternative)"}
      >
        {label ?? placeholder}
      </UI.Typography>
    </Container>
  );
};

export default React.memo(DropdownItem);
